require("babel-core/register");
require("babel-polyfill");
require('./views/main');
require('./css/main.less');
require('./captions-wave-adapter');
require('webpack-jquery-ui');




// WEBPACK FOOTER //
// ./app/index.js